import { Component, ViewChild } from '@angular/core';
import { FloatLabelType } from '@angular/material/form-field';
import { MerchantTableViewComponent } from '../../components/merchant/merchant-table-view/merchant-table-view.component'; 
import { TransactionTableViewComponent } from '../../components/transaction/transaction-table-view/transaction-table-view.component';
import { AccessManager } from '../../components/ui/access-manager/access-manager';
import { TableView } from '../../components/ui/filterable-table/tableView';
import { UIErrorHandler } from '../../core/uiErrorHandler';
import { StorageService } from '../../core/storage/storageService';
import { Merchant } from '../../models/merchant/merchant';
import { TransactionFacade } from '../../models/transactions/transactionFacade';
import { BasePage } from '../BasePage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  standalone: false,
})
export class DashboardComponent extends BasePage {
  @ViewChild('merchantTable') merchantTableControl:
    | MerchantTableViewComponent
    | undefined;
  @ViewChild('transactionsTable') transactionTableControl:
    | TransactionTableViewComponent
    | undefined;

  // These must be set to true on page load, or else any controls with *ngIf
  // will not be initizlied in the DOM, even if these bools are updated later.
  //allowMyBusinesses:boolean = true;
  allowMyMIDs: boolean = true;
  allowMyTransactions: boolean = true;
  allowMetrics = true;

  allowGlobalSearch: boolean = false;
  //allowEditBusinesses:boolean = false;

  numberOfMyMids: number = -1;
  //numberOfMyBusinesses:number = -1;
  firstMIDid: string | undefined = undefined;

  transactionTableView: any;

  transactionsTableOptions: any = {
    paginated: false,
    filterable: false,
  };

  merchantTableView: any;

  merchantTableOptions: any = {
    allowFavorites: false,
    restrictToMyMerchants: true,
    allowImpersonate: false,
    paginated: false,
    filterable: false,
  };

  // businessTableOptions:any = {
  //   paginated: false,
  //   filterable: false,
  // }

  viewingSearchDetails: boolean = false;

  selectedTransaction: Partial<TransactionFacade> | undefined;

  merchantsTableView: any;
  transactionsTableView: any;
  // businessesTableView:any;

  displayResults: boolean = false;

  txtSearch_focus() {
    this.displayResults = true;
  }

  txtSearch_blur() {
    this.displayResults = false;
  }

  constructor(
    public storage: StorageService,
    private accessManager: AccessManager,
    private router: Router,
    private uiErrorHandler: UIErrorHandler,
  ) {
    //FOR NOW JUST REDIRECT TO THE BUSINESS TAB
    super();
    this.router.navigate(["/merchants"]);

    this.transactionsTableView = new TableView(TransactionTableViewComponent);
    this.merchantsTableView = new TableView(MerchantTableViewComponent);
  }

  override ngOnInit() {
    super.ngOnInit();

    // if (this.storage.getMyAccount()) {
    //   this.router.navigate(["my-account"]);
    // } else {
    this.storage.removeSelectedAccount();
    this.storage.removeSelectedCustomer();
    this.storage.removeSelectedLocation();
    this.storage.removeSelectedUser();
    this.storage.removeSelectedCustomer();
    // }
  }

  ngAfterViewInit() {
    let usr = this.storage.getCurrentUser();

    if (usr?.originalRole == 'portal.merchant') {
      this.router.navigateByUrl('merchant/account');
    }

    //if (!usr) {
    //  throw "no current user";
    //}

    this.accessManager
      .getUserAccess([
        AccessManager.AUTH_DASHBOARD_FAVORITES,
        AccessManager.AUTH_IMPERSONATE_USER,
        AccessManager.AUTH_IMPERSONATE_USER,
        AccessManager.AUTH_GLOBAL_SEARCH,
        AccessManager.AUTH_DASHBOARD_MYBUSINESSES,
        AccessManager.AUTH_DASHBOARD_MYMERCHANTS,
        AccessManager.AUTH_DASHBOARD_MYTRANSACTIONS,
        AccessManager.AUTH_DASHBOARD_METRICS,
      ])
      .then((access) => {
        this.merchantTableOptions.allowFavorites =
          access[AccessManager.AUTH_DASHBOARD_FAVORITES];
        this.merchantTableOptions.allowImpersonate =
          access[AccessManager.AUTH_IMPERSONATE_USER];
        this.merchantTableOptions.restrictToMyMerchants = false;
        this.merchantTableOptions.filterable = true;
        this.allowGlobalSearch = access[AccessManager.AUTH_GLOBAL_SEARCH];
        // this.allowMyBusinesses = access[AccessManager.AUTH_DASHBOARD_MYBUSINESSES];
        this.allowMyMIDs = access[AccessManager.AUTH_DASHBOARD_MYMERCHANTS];
        this.allowMyTransactions =
          access[AccessManager.AUTH_DASHBOARD_MYTRANSACTIONS];
        this.allowMetrics = access[AccessManager.AUTH_DASHBOARD_METRICS];

        // if (this.allowMyBusinesses) {
        //   this.businessesTableView = new TableView(AccountTableViewComponent);
        //   this.businessTableOptions.userId = usr?.id;
        // }

        if (this.allowMyTransactions) {
          this.transactionsTableOptions.userId = usr?.id;
          this.transactionsTableOptions.merchantId =
            this.storage.getSelectedLocation()?.id;
          this.transactionTableView = new TableView(
            TransactionTableViewComponent,
          );
          this.transactionTableControl?.setOptions(
            this.transactionsTableOptions,
          );
        }

        if (this.allowMyMIDs) {
          this.merchantTableView = new TableView(MerchantTableViewComponent);
          this.merchantTableControl?.setOptions(this.merchantTableOptions);
        }

        // this.numberOfMyBusinesses = this.storage.getNumberOfMyBusinesses();

        // This is necessary in order to set the width of the modal search results
        // to match the flex width of the text input area

        let el = document.getElementById('textboxContainer');
        //console.log(el?.clientWidth, el?.offsetWidth);

        let el2 = document.getElementById('searchResults');
        el2?.style.setProperty('width', el?.offsetWidth + 'px');
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  public handleMerchantSelected(merchant: Merchant) {
    //this.storageService.setCurrentOrganization(merchant);
    //this.router.navigate(["merchant-account"])
  }

  public handleTransactionSelected(transaction: TransactionFacade) {
    this.selectedTransaction = transaction;
  }

  // public handleBusinessSelected(business:Account) {
  //   this.accountService.getAccount(business.id)
  //   .then(account => {
  //     this.storage.setSelectedAccount(account);
  //     this.router.navigate(["business"])
  //   }).catch(message => {
  //     this.uiErrorHandler.handleError(message);
  //   })
  // }

  // public handleBusinessesRefreshed(refreshedData:any) {
  //   //console.log("MIDs refreshed: " + JSON.stringify(refreshedData));
  //   //this.numberOfMyBusinesses = refreshedData.recordCount;
  // }

  //public handleMerchantsRefreshed(recordCount:number) {
  public handleMerchantsRefreshed(refreshedData: any) {
    this.numberOfMyMids = refreshedData.recordCount;

    // TODO: This is a bit of a hack:
    // Since we have already queried for myMIDs (via the merchants table),
    // rather than query again for a distinct list, we access the id of
    // the first mid in the list to use in the case where there is only
    // one MID to select.
    this.firstMIDid = refreshedData.firstId;
  }

  getFloatLabelValue(): FloatLabelType {
    return 'auto';
  }

  checkRecordDetailsIsVisible(isVisable: boolean) {
    this.viewingSearchDetails = isVisable;
  }
}
